import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfirmationService, MegaMenuItem } from 'primeng/api';
import { PrimeNGModule } from '../../../primeng.module';
import { AuthService } from '../../../services/auth/auth.service';
import User from '../../models/user/user';
import {
  BreadcrumbComponent,
  BreadcrumbData,
} from '../breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-customer-area',
  standalone: true,
  imports: [BreadcrumbComponent, PrimeNGModule, RouterModule],
  templateUrl: './customer-area.component.html',
  styleUrl: './customer-area.component.scss',
})
export class CustomerAreaComponent implements OnInit {
  public activeItem: MegaMenuItem | undefined;
  public category: BreadcrumbData = new BreadcrumbData();
  public pathBreadcrumb: string = '';
  public subCategory: BreadcrumbData = new BreadcrumbData();
  public showCategory = true;
  public showSubCategory = false;
  public itemsMenu: MegaMenuItem[] = [];
  public user: User | undefined = new User();

  constructor(
    private authService: AuthService,
    private confirmationService: ConfirmationService
  ) {
    this.authService.userData$.subscribe((res: any) => {
      this.user = undefined;
      if (res) {
        this.user = new User();
        this.user.fromJson(res);
      }
      this.setMenu();
    });
  }

  ngOnInit() {
    this.category = {
      title: 'Área do Cliente',
      path: 'area-do-cliente',
      id: 'area-do-cliente',
    };
  }

  setMenu() {
    if (this.user?.isAdmin) {
      this.setMenuAdmin();
    } else {
      this.setMenuCustomer();
    }
  }

  setMenuAdmin() {
    //TODO:
    this.setMenuCustomer();
  }

  setMenuCustomer() {
    this.itemsMenu = [
      {
        label: 'Meus Pedidos',
        icon: 'pi pi-book',
        routerLink: 'meus-pedidos',
      },
      {
        label: 'Meus Dados',
        icon: 'pi pi-pencil',
        routerLink: 'meus-dados',
      },
      {
        label: 'Meu Endereço',
        icon: 'pi pi-home',
        routerLink: 'meu-endereco',
      },
      {
        label: 'Sair',
        icon: 'pi pi-power-off',
        command: () => this.logout(),
      },
    ];
  }

  async logout() {
    this.confirmationService.confirm({
      message: 'Deseja realmente sair de sua conta?',
      header: 'Confirmação',
      accept: () => {
        this.authService.logout();
      },
    });
  }

  setConfig(component: any) {
    this.showCategory = false;
    this.showSubCategory = true;

    const componentName = component.constructor.name;

    switch (componentName) {
      case 'OrdersCustomersComponent':
        this.subCategory = {
          title: 'Meus Pedidos',
          path: 'meus-pedidos',
          id: 'meus-pedidos',
        };
        this.pathBreadcrumb = 'Área do Cliente - Meus Pedidos';
        break;

      case 'DataCustomersComponent':
        this.subCategory = {
          title: 'Meus Dados',
          path: 'meus-dados',
          id: 'meus-dados',
        };
        this.pathBreadcrumb = 'Área do Cliente - Meus Dados';
        break;

      case 'AddressCustomersComponent':
        this.subCategory = {
          title: 'Meu Endereço',
          path: 'meu-endereco',
          id: 'meu-endereco',
        };
        this.pathBreadcrumb = 'Área do Cliente - Meu Endereço';
        break;

      default:
        this.subCategory = new BreadcrumbData();
        this.pathBreadcrumb = '';
    }
  }
}
